module.exports = __webpack_public_path__ + "static/media/Decisions_Step1_Image7.23703d09.jpg";